import tableMixin from '@/components/table/table-mixin'
import url from '@/utils/url'
import { LEVEL_CSS_CLASS_MAP } from '@/config/config'

export default {
  mixins: [tableMixin],
  methods: {
    getItemClass(item) {
      let lvl = +(item.lvl || 1)
      if (LEVEL_CSS_CLASS_MAP[lvl]) {
        return LEVEL_CSS_CLASS_MAP[lvl]
      }
      return ''
    },
    isOpened(item) {
      return this.items.data.findIndex((v) => v.parent_id === item.id) > -1
    },
    closeChild(row) {
      let ids = []
      this.items.data.forEach((v) => {
        if (v.parent_id === row.id) {
          ids.push(v.id)
          this.closeChild(v)
        }
      })

      this.$store.dispatch('deleteModels', {
        endpoint: this.getEndpoint(this.$route),
        ids: ids,
        offline: true,
      })
      this.tableUpdate = false
    },
    openChild(row) {
      if (this.isOpened(row)) {
        return false
      }

      this.$bar.start()
      this.$store
        .dispatch('updateUrlEndpoint', {
          endpoint: this.getEndpoint({
            query: {
              parent_id: row.id,
              'per-page': -1,
            },
          }),
          useCache: true,
          params: {
            disableGlobalError: true,
          },
        })
        .then((response) => {
          let parentLvl = row.lvl || 1
          response.data.data.forEach((v, i) => {
            response.data.data[i].lvl = parentLvl + 1
          })
          this.$store.commit('mutateEndpoint', {
            endpoint: this.getEndpoint(this.$route),
            action: 'insertAfter',
            id: row.id,
            response,
          })
          this.tableUpdate = true
          this.$bar.finish()
        })
        .catch((e) => {
          this.showOnError(e)
          this.$bar.finish()
        })
    },
  },
  asyncData({ store, route, fromRoute, methods }) {
    const endpoint = methods.getEndpoint(route, fromRoute)
    // if open modal
    if (fromRoute) {
      let jsonRoute = url.getRoute(fromRoute, true)

      if (route.query.prevRoute && route.query.prevRoute === jsonRoute) {
        // fix: https://redmine.etton.ru/issues/13458
        if (store.getters.readUrlEndpoint(endpoint)) {
          return Promise.resolve(1)
        }
      }
    }

    return store.dispatch('updateUrlEndpoint', { endpoint })
  },
}
